import type { Locale, MessageKey } from '@/i18n'
import type { ProcessState } from '../projection'

/** A step's name in the person's language (step registry), or its code. */
export function stepName(state: ProcessState, code: string, locale: Locale): string {
  const s = state.steps.get(code)
  return s ? (locale === 'hi' ? s.hi : s.en) : code
}

const FIXED_OUTPUTS = ['FLUSH', 'LEFTOVER', 'SPILLAGE']

/** An output's name: flush / leftover / spillage from the dictionary, the rest from the registry. */
export function outputName(
  state: ProcessState,
  stepCode: string,
  key: string,
  locale: Locale,
  t: (k: MessageKey) => string,
): string {
  if (FIXED_OUTPUTS.includes(key)) return t(`process.output.${key}` as MessageKey)
  const o = state.steps.get(stepCode)?.outputs.find((x) => x.key === key)
  return o ? (locale === 'hi' ? o.hi : o.en) : key
}

export const PROBLEM_TYPES = [
  'BALANCE_OUT_OF_BAND',
  'RUN_MIXED',
  'LATE_ENTRY',
  'BAG_COUNT_MISMATCH',
  'TAG_CONFLICT',
  'TAG_REUSED',
  'LABEL_MISMATCH',
  'WEIGHT_OUT_OF_RANGE',
  'LAB_FAIL',
  'OTHER',
] as const

/** Dictionary key for a problem type; anything new reads as a general problem. */
export function problemKey(type: string): MessageKey {
  return `process.problem.${(PROBLEM_TYPES as readonly string[]).includes(type) ? type : 'OTHER'}` as MessageKey
}
